import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {isOutOfOrder} from '../../utils/functions/Functions';
import './ReviewOfferPage.scss';
import {resetHighestPageHit, updateCurrentModalPage, updateShowModalFlag} from '../../redux/app-state-slice';
import RejectedOfferInfo from './Rejected/RejectedOfferInfo';
import CreditFreezeInfo from './CreditFreeze/CreditFreezeInfo';
import {logService} from '../../Services/LogService/LogService';
import ApprovedOfferInfo from './Approved/ApprovedOfferInfo';

function ReviewOfferPage({dispatch, customerData, appConfig}) {
  const navigate = useNavigate();
  const result = customerData.result.value;
  const decision = result?.decisionCode;

  function logPrequalOfferPage() {
    let logInfo = {
      logType: 'TIER1_SUBMITTING_APPLICATION',
      countryCode: customerData.countryCode.value
    };
    if (customerData.isDealerHostApplication.value) {
      logInfo = {
        logType: 'TIER3_SUBMITTING_APPLICATION',
        paCode: customerData.tier3PACode.value,
        prequalSource: customerData.prequalSource.value,
        vin: customerData.tier3Vin.value
      };
    }
    logService(logInfo, appConfig)
      .then(() => {})
      .catch(() => {});
  }

  useEffect(() => {
    if (!customerData.isDealerHostApplication.value && !appConfig?.modalFlag && isOutOfOrder(customerData)) {
      navigate('/');
    }
    dispatch(resetHighestPageHit());
    if (!customerData.isDealerHostApplication.value) {
      dispatch(updateShowModalFlag(false));
      dispatch(updateCurrentModalPage(''));
    }
    logPrequalOfferPage();
  }, []);
  const getReviewOfferSectionCssClass = () => {
    if (customerData.isDealerHostApplication.value) {
      return 'prequal--wc--form-section';
    }
    return 'prequal--web--review-offer-section prequal--web--review-offer-section-fomo-padding';
  };
  if (result && result.frozenLockIndicator !== 'N') {
    return (
      <div id='prequal--web--form-section' className={getReviewOfferSectionCssClass()}>
        <CreditFreezeInfo result={result} customerData={customerData} dispatch={dispatch} appConfig={appConfig} />
      </div>
    );
  }
  return (
    <div id='prequal--web--form-section' className={getReviewOfferSectionCssClass()}>
      {decision === 'APPROVED' ? (
        <ApprovedOfferInfo result={result} customerData={customerData} appConfig={appConfig} dispatch={dispatch} />
      ) : (
        <RejectedOfferInfo result={result} customerData={customerData} appConfig={appConfig} dispatch={dispatch} />
      )}
    </div>
  );
}

export default ReviewOfferPage;
